import { ICreatorTheme } from "../../../../../features/Common/modules/Theme/theme.interface";
import { getColorsFromCreatorTheme } from "../../../../../features/Common/modules/Theme/utils/Theme.utils";
import { getStylesObjFromCss } from "../../../../../utils/common/styling";

export const styles = getStylesObjFromCss({
  styles: {
    container: {
      display: "flex",
      gap: "10px",
      alignItems: "baseline",
    },
    detailsAndReactionsAndReplies: { flexGrow: 1 },
    detailsContainer: {
      backgroundColor: "#F8F8F8",
      borderRadius: "8px",
      position: "relative",
      padding: "12px",
      fontSize: "14px",
      fontWeight: "500",
    },
    triangle: {
      position: "absolute",
      borderTop: "6px solid transparent",
      borderBottom: "6px solid transparent",
      borderRight: "6px solid #F8F8F8",
      left: "-6px",
      top: "15px",
    },
    triangle2: {
      position: "absolute",
      borderTop: "6px solid transparent",
      borderBottom: "6px solid transparent",
      borderRight: "6px solid #F8F8F8",
      left: "-4.5px",
      top: "15px",
    },
    header: {
      display: "flex",
      justifyContent: "space-between",
      gap: "8px",
    },
    commenterName: {
      display: "-webkit-box",
      WebkitLineClamp: "1",
      WebkitBoxOrient: "vertical",
      WebkitAlignContent: "bottom",
      WebkitAlignItems: "bottom",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    creatorCommentSymbolSpan: {
      marginLeft: "4px",
      display: "inline-flex",
      dominantBaseline: "inherit",
      verticalAlign: "text-top",
    },
    commenterNameClickable: {
      cursor: "pointer",
      "&:hover": {
        textDecoration: "underline",
      },
    },
    authorIsCurrentUserIndicator: {
      color: "rgba(0, 0, 0, 0.40)",
      fontSize: "16px",
      fontWeight: 400,
    },
    createdAtAndMoreIcon: {
      display: "flex",
      alignItems: "center",
      fontSize: "12px",
      fontWeight: "400",
    },
    createdAt: {
      color: "rgba(39, 37, 34, 0.50)",
      display: "-webkit-box",
      WebkitLineClamp: "1",
      WebkitBoxOrient: "vertical",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    moreIconContainer: {
      position: "relative",
      top: "-3px",
      right: "-8px",
      cursor: "pointer",
      lineHeight: "0",
    },
    commentText: {
      color: "#272522cc",
      whiteSpace: "pre-wrap",
      wordBreak: "break-word",
    },
    attachments: {
      display: "flex",
      flexWrap: "wrap",
      marginTop: "16px",
      gap: "16px",
    },
    image: {
      cursor: "pointer",
      objectFit: "cover",
      width: "115px",
      height: "75px",
    },
    reactionsStrip: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "8px 0",
      fontSize: "14px",
    },
    reactionsStripLeft: {
      display: "flex",
      alignItems: "center",
      gap: "20px",
    },
    likesContainer: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
    },
    likesCount: { color: "rgba(39, 37, 34, 0.50)", cursor: "pointer" },
    likeIcon: { cursor: "pointer" },
    likeIconWhenNotLikedByUser: { color: "rgba(39, 37, 34, 0.7)" },
    replyButton: {
      display: "flex",
      alignItems: "center",
      gap: "4px",
    },
    questionnaireResponse: {
      border: "1.5px solid #d3d3d3",
      borderRadius: " 8px",
      padding: "8px 16px",
    },
    flaggedContainer: {
      border: "1px solid #C0392B",
    },
    flaggedTraingle: {
      borderRightColor: "#C0392B",
    },
    table: {
      borderCollapse: "collapse",
      width: "100%",
    },
    picCol: {
      verticalAlign: "baseline",
      "& > div": {
        marginRight: 10,
      },
    },
    commentBubble: {
      width: "100%",
    },
  },
  componentName: "Comment",
});

export const getThemedStyles = ({ theme }: { theme: ICreatorTheme }) => {
  const { color1 } = getColorsFromCreatorTheme(theme);

  return getStylesObjFromCss({
    styles: {
      likeIconWhenLikedByUser: {
        color: color1 || "#493ab1",
      },
      replyButton: {
        color: (color1 || "#493AB1") + " !important",
        "& path": { fill: color1 || "#493AB1" },
      },
    },
    componentName: "Comment",
  });
};
